var alignmentStyle = {"alignLeft":"Vm8Us","textWrapNowrap":"oTa0o","alignRight":"aKH8g","alignCenter":"MsZIB","sizeFullWidth":"y5oLG","renderedInTable":"js7p5","sizeOriginal":"gvwUD","sizeContent":"KAi-c","sizeSmall":"-HrEk","sizeSmallCenter":"aklNN","flex":"_0PaWD","LEFT":"yUIHN","CENTER":"LRRbo","RIGHT":"-iZzv","AUTO":"d0eTW","JUSTIFY":"k9TUT"};

export { alignmentStyle as a };
//# sourceMappingURL=alignment.rtlignore-4565cad7.js.map
